import React from 'react';
import { Button, Form, } from 'reactstrap';
import { mapValues } from 'lodash';
import { useToggle } from 'react-use';

import { fieldsToSignIn as fields } from '../../shared/models/user';
import useFormState from '../hooks/useFormState';
import Field from '../Field';
import PasswordResetFormModal from '../modals/PasswordResetFormModal';

const { entries } = Object;

export default function SignInForm(props) {
  const { isOpen, values, isForStaff, } = props;
  const [showsPasswordResetFormModal, togglePasswordResetFormModal] = useToggle();
  const statedFields = useFormState(values, fields({ isForStaff }), isOpen);
  const isUnsubmittable = Object.values(statedFields).some(_ => !_.isValid);
  const onSubmit = (event) => {
    event.preventDefault();
    if(isUnsubmittable) return;
    props.onSubmit({ ...mapValues(statedFields, 'value') });
  };

  return (
    <Form onSubmit={onSubmit}>
      <div>
        {
          entries(statedFields).map(([fieldName, fieldSetting]) => (
            <Field
              hiddenRequiredLabel
              key={fieldName}
              name={fieldName}
              {...fieldSetting}
            />
          ))
        }
      </div>
      <div>
        <Button block type="submit" color="primary" onClick={onSubmit} disabled={isUnsubmittable}>ログイン</Button>
      </div>
      {
        !isForStaff && (
          <div className="text-muted mt-2">
            パスワードをお忘れの方は
            <span className="text-primary cursor-pointer" onClick={togglePasswordResetFormModal}>
              こちら
            </span>
          </div>
        )
      }
      {showsPasswordResetFormModal && <PasswordResetFormModal isOpen onClickClose={togglePasswordResetFormModal} />}
    </Form>
  );
};
